export const PRIMARY_COLOR = '#FF3A3A';
export const PREFFIX = "/koc/task/";

export const FULL_WIDTH = window.innerWidth || document.documentElement.clientWidth;
export const FULL_HEIGHT = window.innerHeight || document.documentElement.clientHeight;
